import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M5.2145 8.1486l4.945-5a.4995.4995 0 01.707-.004c.197.194.199.511.004.707l-4.114 4.159c1.779-.004 5.161-.01 7.313-.01 3.131 0 5 2.055 5 5.5v6c0 .276-.223.5-.5.5-.276 0-.5-.224-.5-.5v-6c0-1.681-.519-4.5-4-4.5-2.14 0-5.495.006-7.282.01l4.136 4.136a.5003.5003 0 01-.354.854.4985.4985 0 01-.353-.147l-5-5a.5007.5007 0 01-.002-.705',
  ],
  height: 24,
  width: 24,
});
